import { createContext, useContext } from 'react'

export const BookDemoContext = createContext<(source?: string) => void>(() => {})
export const useBookDemo = () => useContext(BookDemoContext)
